// #region styled components
import styled from 'styled-components';

export const CustomizerLayoutContainer = styled.div`
	user-select: none;
	position: absolute;
	inset: 0;
	display: flex;
`;
